
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ReasonidService } from 'src/app/service/reasonid.service';

@Component({
    selector: 'app-copy-tier-dialog',
    templateUrl: './copy-tier-dialog.component.html',
    styleUrls: ['./copy-tier-dialog.component.scss'],
    standalone: false
})
export class CopyTierDialogComponent implements OnInit{
  heading: string;
  fromPeriodLabel: string;
  toPeriodList = [];
  fromPeriodList = [];
  selected_period_id;
  selected_period_value
  selected_from_period_id
  enableError = false;
  errormsg: string;
  errorMessage 
  successMessage
  selectedPeriod: any;
  selected_from_period_value
  constructor(public dialogRef: MatDialogRef<CopyTierDialogComponent >, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly constants: Constants,@Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly targetService : ReasonidService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.getPeriods_from();
    this.getPeriods();
  }
  getPeriods_from() {
    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.fromPeriodList = tempPeriod
      this.selected_from_period_id = this.fromPeriodList[0].periodId;
      this.selected_from_period_value = this.fromPeriodList.find(x => x.periodId == this.selected_from_period_id).period // NOSONAR
    } else {
      this.targetService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.fromPeriodList = response
            this.selected_from_period_id = this.fromPeriodList[0].periodId;
            this.selected_from_period_value = this.fromPeriodList.find(x => x.periodId == this.selected_from_period_id).period // NOSONAR
          }
        }, error => {
          console.info(error)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errormsg = this.constants.APIErrorMessage
          setTimeout(() => {
            this.errormsg = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );
    }
  }
  getPeriods() {
    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.toPeriodList = tempPeriod
      this.selected_period_id = this.toPeriodList[0].periodId;
      this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period // NOSONAR
    } else {
      this.targetService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.toPeriodList = response
            this.selected_period_id = this.toPeriodList[0].periodId;
            this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period // NOSONAR
          }
        }, error => {
          console.info(error)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errormsg = this.constants.APIErrorMessage
          setTimeout(() => {
            this.errormsg = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );
    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    if (this.selected_from_period_id) {
      this.selected_from_period_value = this.fromPeriodList.find(x => x.periodId == this.selected_from_period_id).period // NOSONAR
      if (this.selected_period_id) {
        this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
        if (this.selected_from_period_value == this.selected_period_value) { // NOSONAR
          this.enableError = true;
          this.errormsg = "From/To Periods must be different."
        } else
        {
          this.dialogRef.close({
            event: "SaveEvent", selected_period_id: this.selected_period_id, selected_period_value: this.selected_period_value, selected_from_period_id : this.selected_from_period_id
          });
        }
    }
   } else {
      this.enableError = true;
      this.errormsg = "select to-period"
    }
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }
}
